import { render, staticRenderFns } from "./SchoolEngagementTab.vue?vue&type=template&id=02296004"
import script from "./SchoolEngagementTab.vue?vue&type=script&lang=js"
export * from "./SchoolEngagementTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports